export default {
	title: 'Risks / Openings',
	risks: 'Risks',
	opportunities: 'Openings',
	url: 'risks',
	subtitle: '',
	all_categories: 'Categories filter',
	all_impacts: 'Impact filter',
	all_likelihoods: 'Likelihood filter',
	all_stakeholders: 'Stakeholders filter',
	all_stakes: 'Stakes filter',
	no_stakeholder: 'No stakeholder',
	tabs: {
		filters: {
			title: 'View filters',

			displayed_columns: 'Displayed columns',
			visualization_options: 'Visualization options'
		},
		options: {
			title: 'Display',
			are_links_visible: 'Show all links',
			show_description: 'Show description',
			chart_visible_stakes: 'Show stakes',
			chart_visible_stakeholders: 'Show stakeholders',
			chart_visible_risks: 'Show risks',
			chart_visible_opportunities: 'Show openings'
		},
		general: {
			title: 'General'
		},
		stakeholders: {
			title: 'Stakeholders'
		},
		export: {
			title: 'Export'
		},
		comments: {
			title: 'History'
		}
	},
	visualization_tab: 'Visualization',
	onboarding: {
		risks: {
			title: 'Review your risks',
			description:
				"Here are the risks weighing on your stakes. Assess their likelihood and impact, and correct any that seem miscalibrated."
		},
		opportunities: {
			title: 'Review your openings',
			description:
				"Unlike risks, openings are dynamics that can strengthen your stakes. Keep the actionable ones, set the rest aside."
		}
	}
};
